import * as React from 'react';
import { Grid, Row, Col } from 'react-flexbox-grid';
import Divider from 'material-ui/Divider';
import { Input, InputField, AutoComplete, AutoCompleteField, InlineGridField, InlineGrid } from '@components/form';
import { itemStateEnum } from './_operationalWarehouseEnums';
import { get } from 'lodash';
import { operationalWarehouseFormFilesColumns } from './_operationalWarehouseColumns';

const View: React.SFC<any> = ({ files }) => (
  <div>
    <Grid fluid={true}>
      <Row>
        <Col className="grid-system-margin" />
      </Row>
      <Row>
        {[
          { name: 'name', label: 'Název', disabled: true },
          { name: 'category.name', label: 'Kategorie', disabled: true },
          { name: 'warehouse.name', label: 'Sklad', disabled: true },
          {
            name: 'state',
            label: 'Stav předmětu',
            disabled: true,
            ComponentField: AutoCompleteField,
            Component: AutoComplete,
            items: itemStateEnum,
            valueFunction: o => get(o, 'id'),
            labelFunction: o => get(o, 'label')
          },
          { name: 'employee.fullName', label: 'Strážník', disabled: true },
          { name: 'note', label: 'Poznámka' }
        ].map(({ ComponentField = InputField, Component = Input, ...field }: any) => (
          <Col xs={12} key={field.name}>
            <ComponentField component={Component} id={field.name} {...field} />
          </Col>
        ))}
      </Row>
      {files && files.length ? (
        <>
          <Row>
            <Col className="grid-system-margin" />
          </Row>
          <Row>
            <Col xs={12}>
              <h3>Soubory</h3>
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <InlineGridField
                component={InlineGrid}
                name="files"
                Form={undefined}
                columns={operationalWarehouseFormFilesColumns}
                showCheckboxes={false}
                deleting={false}
                editing={false}
                adding={false}
                filtering={false}
                version="1"
              />
            </Col>
          </Row>
          <Row>
            <Col className="grid-system-margin" />
          </Row>
        </>
      ) : (
        <></>
      )}
    </Grid>

    <Divider />
  </div>
);
export const OperationalWarehouseFormBasic = View;



// WEBPACK FOOTER //
// ./src/modules/operationalWarehouse/operationalWarehouseFormBasic.tsx